export default __webpack_public_path__ + "2a1c3ab7c6fda5bba2b69f29ba0d08c7.jpg";